import React, {Fragment} from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";

class ExactProductForm extends React.Component {
    render() {
        return (
            <Fragment>
                <div className="row form-row">
                    <div className="col-sm-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-10">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Megnevezés/Név"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="listprice"
                            type="number"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Lista ár"
                        />
                    </div>
                    <div className="col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="barcode"
                            type="number"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Vonalkód"
                        />
                    </div>
                    <div className="col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="booklog_id"
                            disabled={true}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Booklog ID"
                        />
                    </div>
                </div>
            </Fragment>
        );
    }
}

class productShortFormComponent extends React.Component {
    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <ExactProductForm {...this.props} />
            </form>
        );
    }
}

export const productShortForm = createForm(productShortFormComponent);

class productForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <ExactProductForm {...this.props} />
            </form>
        );
    }
}

export default createForm(productForm);